"use strict";

$.widget("fotobook.dateMarksMulticolumnDropdown", $.fotobook.multicolumnDropdown, {
    _renderOptionContent: function(mark, idx){
        return Fotobook.holidays.renderer.drawMarkFigure({
            "mark_id" : mark.id,
            "mark_color" : mark.color,
            "color" : mark.text_color,
        });
    },
    _getOptionsData: function(){
        var selected = this.options.selectedValue;

        return $.map(Fotobook.holidays.marks.getAll(), function(mark, idx){
            return {
                "value" : mark.id,
                "text" : mark.id,
                "selected" : mark.id == selected,
                "item" : mark,
            };
        });
    },
    _create: function(){
        this._createOptions();
        this._super();
    },
});

